import React, {Component} from 'react'
import WithAuthentication from "./WithAuthentication"
import {Redirect, withRouter} from "react-router-dom"
import createApiServices from '../../services/api/createApiServices'
import {getRefreshToken, isLegacyUserRoleOnly, logoutUser} from '../../services/AuthServices'
import {refreshToken} from "../../services/api/UserService"
import {parseJwt} from "../../helpers/parseToken"
import * as AuthServices from "../../services/AuthServices"
import {getLocalData} from "../../services/StorageServices"

class EnsureLoggedIn extends Component {
    state = {
        load: false,
        isRefreshFailed: false
    }
    _api = createApiServices()

    _handleRefreshToken = async () => {
        try {
            const payload = {
                refreshToken: getRefreshToken()
            }

            const {data, success} = await refreshToken(payload)

            if (!success) return this._handleRefreshFailed()

            const {accessToken, permissions, refreshToken: refreshTok} = data

            const timeExp = parseJwt(accessToken).exp - parseJwt(accessToken).iat

            AuthServices.setAccessToken(accessToken)
            AuthServices.setUserPermissions(permissions)
            AuthServices.setRefreshToken(refreshTok)
            AuthServices.setTimeExp((timeExp - 300) * 1000 + new Date().getTime())
            this.setState({
                load: true
            })
        } catch (e) {
            this._handleRefreshFailed()
        }
    }

    /**
     * @FAC-26403: làm mới token thất bại thì đăng xuất và chuyển về màn đăng nhập ngay,
     * không chờ WithAuthentication nhận broadcast (setTimeout) để tránh kẹt "Đang tải..."
     * logoutUser nhận đường dẫn để LoginPage đưa user quay lại trang đang mở sau khi đăng nhập
     */
    _handleRefreshFailed = () => {
        const {pathname, search} = this.props.location

        logoutUser(pathname + (search || ''))
        this.setState({
            load: true,
            isRefreshFailed: true
        })
    }

    /**
     * @FAC-26042: ngoài token hết hạn, làm mới cả khi còn key cũ `userRole` mà chưa có `userPermission`
     * (user đăng nhập từ trước khi đổi key) để lấy lại permissions.
     */
    _shouldRefreshToken = () => {
        const isExpired = new Date().getTime() > getLocalData('timeExp')

        return (isExpired || isLegacyUserRoleOnly()) && !!getRefreshToken()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({load: false})

        if (this._shouldRefreshToken()) {
            this._handleRefreshToken()
        } else {
            this.setState({
                load: true
            })
        }
        this._api.subscribeErrorRequest(error => {
            const {status, data} = error
            if (status === 403 || status === 401) {
                const {message} = Object.assign({}, data)
                logoutUser(message || '')
            }
        })
    }

    componentWillMount() {
        if (this._shouldRefreshToken()) {
            this._handleRefreshToken()
        } else {
            this.setState({
                load: true
            })
        }
        this._api.subscribeErrorRequest(error => {
            const {status, data} = error

            if (status === 403 || status === 401) {
                const {message} = Object.assign({}, data)
                logoutUser(message || '')
            }
        })
    }

    render() {
        const {location} = this.props

        return (
            <WithAuthentication>
                {
                    ({isAuthenticated}) => {
                        const {load, isRefreshFailed} = this.state

                        return load ? isAuthenticated && !isRefreshFailed ? this.props.children : <Redirect to={{
                            pathname: "/login",
                            state: {referrer: location.pathname + (location.search || '')}
                        }}/> : <div className="text-center bg-white">Đang tải...</div>
                    }
                }
            </WithAuthentication>
        )
    }
}

export default withRouter(EnsureLoggedIn)
